import React, { PropsWithChildren } from 'react';

import { Box } from '@betterment/samba-react';

import { TaxImpactGainsAllowanceWarning } from './TaxImpactGainsAllowanceWarning';

import { DetailRow } from '../detail-row/DetailRow';
import { DetailRowLabel } from '../detail-row/DetailRowLabel';
import { DetailRowTooltip } from '../detail-row/DetailRowTooltip';
import { DetailRowValue } from '../detail-row/DetailRowValue';

interface TaxImpactGainsAllowanceRemainingProps extends PropsWithChildren {
  showGainsAllowanceWarning?: boolean;
}

export const TaxImpactGainsAllowanceRemaining: React.FC<TaxImpactGainsAllowanceRemainingProps> = ({
  children,
  showGainsAllowanceWarning,
}) => {
  return (
    <DetailRow>
      <Box css={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <DetailRowLabel>
          Remaining gains allowance
          <DetailRowTooltip data-testid="gains-allowance-remaining-tooltip">
            The remaining gains allowance budget for your client. This amount includes gains and losses from expected
            actions and trades.
          </DetailRowTooltip>
        </DetailRowLabel>
        {showGainsAllowanceWarning && <TaxImpactGainsAllowanceWarning />}
      </Box>
      <DetailRowValue>{children}</DetailRowValue>
    </DetailRow>
  );
};
